(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-hero]');
    if (!root) return;

    // Thumbs and gallery figures are linked by data-media-id (both carry it),
    // so scope each query to its own container.
    const thumbWrap = root.querySelector('.product-hero__thumbs');
    const gallery = root.querySelector('[data-product-gallery]');
    const thumbs = thumbWrap ? Array.from(thumbWrap.querySelectorAll('[data-media-id]')) : [];
    const medias = gallery ? Array.from(gallery.querySelectorAll('[data-media-id]')) : [];

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.mediaId;
        const target = gallery && gallery.querySelector('[data-media-id="' + id + '"]');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    if (medias.length && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const id = entry.target.dataset.mediaId;
              thumbs.forEach((t) => {
                t.classList.toggle('is-active', t.dataset.mediaId === id);
              });
            }
          });
        },
        { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
      );
      medias.forEach((m) => observer.observe(m));
    }

    const tabs = root.querySelectorAll('[data-tab-target]');
    const panels = root.querySelectorAll('[data-tab-panel]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tabTarget;
        tabs.forEach((t) => {
          const active = t.dataset.tabTarget === target;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((p) => {
          p.classList.toggle('is-active', p.dataset.tabPanel === target);
        });
      });
    });

    // ── Variant selection (swatches + selects) ──
    const form = root.querySelector('.js-product-form');
    const variantsTag = root.querySelector('[data-variants-json]');
    if (form && variantsTag) {
      let variants = [];
      try {
        variants = JSON.parse(variantsTag.textContent);
      } catch (err) {
        variants = [];
      }

      const idInput = form.querySelector('input[name="id"]');
      const priceEl = root.querySelector('[data-product-price]');
      const submit = form.querySelector('[name="add"]');
      const containers = Array.from(form.querySelectorAll('[data-option-index]'));

      const selections = () => {
        const sel = [];
        containers.forEach((c) => {
          const pos = parseInt(c.dataset.optionPosition, 10) - 1;
          const select = c.querySelector('[data-option-select]');
          const active = c.querySelector('[data-option-swatch].is-active');
          sel[pos] = select ? select.value : active ? active.dataset.optionValue : null;
        });
        return sel;
      };

      const findVariant = (sel) =>
        variants.find(
          (v) => v.options.length === sel.length && v.options.every((o, i) => o === sel[i])
        );

      const update = () => {
        const variant = findVariant(selections());
        if (!variant) {
          if (submit) {
            submit.disabled = true;
            submit.textContent = 'Indisponible';
          }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) {
          let html = variant.price;
          if (variant.compare_raw > variant.price_raw) {
            html += ' <span class="product-hero__price-compare">' + variant.compare_at_price + '</span>';
          }
          priceEl.innerHTML = html;
        }
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
        }
        if (variant.media_id != null && gallery) {
          const fig = gallery.querySelector('[data-media-id="' + variant.media_id + '"]');
          if (fig) fig.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (window.history && history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      };

      containers.forEach((c) => {
        const select = c.querySelector('[data-option-select]');
        if (select) select.addEventListener('change', update);
        c.querySelectorAll('[data-option-swatch]').forEach((sw) => {
          sw.addEventListener('click', () => {
            c.querySelectorAll('[data-option-swatch]').forEach((s) => {
              s.classList.remove('is-active');
              s.setAttribute('aria-pressed', 'false');
            });
            sw.classList.add('is-active');
            sw.setAttribute('aria-pressed', 'true');
            const label = c.querySelector('[data-option-selected-label]');
            if (label) label.textContent = ': ' + sw.dataset.optionValue;
            update();
          });
        });
      });

      // Initialise the active swatch from the current variant so the colour is
      // part of the selection even before the user clicks a swatch — otherwise
      // changing another option (e.g. lot) can't match a variant and the price
      // would stay stale.
      const initVariant = variants.find(
        (v) => idInput && String(v.id) === idInput.value
      );
      if (initVariant) {
        containers.forEach((c) => {
          const pos = parseInt(c.dataset.optionPosition, 10) - 1;
          const swatches = c.querySelectorAll('[data-option-swatch]');
          if (!swatches.length) return;
          const value = initVariant.options[pos];
          swatches.forEach((sw) => {
            const isActive = sw.dataset.optionValue === value;
            sw.classList.toggle('is-active', isActive);
            sw.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
          const label = c.querySelector('[data-option-selected-label]');
          if (label) label.textContent = ': ' + value;
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
